import React, { useEffect } from 'react';
import { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { StyledLabel } from '../CampaignDetails';
import PortletHeader from '../../../app/components/portlet/PortletHeader';
import Portlet from '../../../app/components/portlet/Portlet';
import TabsSidebar from '../../../app/components/styledComponents/TabsSidebar';
import { isSocialSummaryPost, jobBoardAccessKeys, monsterDuration, sidebar } from '../CampaignsUtils';
import { Wrap } from '../../../assets/styledComponents/Global';
import AdvertPostingDetails from './AdvertPostingDetails';
import JobBoardSummary from './JobBoardSummary';
import SocialMediaSummary from './SocialMediaSummary';
import { useAdvertPostingMutation, useGetCampaignPostingDetailsQuery, useGetJobBoardSummaryQuery, useGetPostingDetailsQuery } from '../CampainApiSlice';
import { useManualAdvertiseMutation } from '../../Job/jobApiSlice';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Form, Formik } from 'formik';


const CampaignPostingDetailPage = () => {
  const { campaignId, postingId } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const [failedResp, setFailedResp] = useState();
  const location = useLocation();
  const status = location.state;
  const { data : campaignPosting, refetch : campaginRefetch } = useGetCampaignPostingDetailsQuery({
    postingIds: postingId,
  },{
    skip : !postingId,
    refetchOnMountOrArgChange:true,
  });
  const jobBoardKeys = campaignPosting && campaignPosting[0]?.jobPostings?.product?.jobboardProducts;
  const socialMediaPost = campaignPosting?.[0]?.socialMediaPost;
  const isSocialMediaSummary = isSocialSummaryPost(campaignPosting?.[0]);
  const needsSocialPublish = isSocialMediaSummary && !socialMediaPost;
  const [advertPosting, {isLoading:postingLoading}] = useAdvertPostingMutation();
  const [manualAdvertise, { isLoading: socialPostLoading }] = useManualAdvertiseMutation();
  const { data: postingDetails,isLoading : postingDetailsLoading,  refetch: refetchPostingDetail } = useGetPostingDetailsQuery({
    params: {
      campaignId: campaignId,
    },
    postingId
  }, { skip: !campaignId || !postingId });
  const refId = postingDetails?.campaignGeneralInfo?.jobPostings[0]?.bbRef;
  const { data: jobBoardsSummaryDetails, refetch: refetchSummaryDetail } = useGetJobBoardSummaryQuery({ refId }, { skip: !refId,
    refetchOnMountOrArgChange:true,
   });



  const checkBoardExist=(accessKey)=>
    jobBoardKeys?.some(
      (item) => item?.jobBoard?.broadbeanShortcode
        === accessKey && item?.posterAccessKey === 'OCCY'
    )

  const showMonsterEditFormKey = checkBoardExist(jobBoardAccessKeys.MONSTER)
  const cvlibraryKey = checkBoardExist(jobBoardAccessKeys.CV_LIBRARY);
  const reedKey = checkBoardExist(jobBoardAccessKeys.REED);
  const totalJobKey = checkBoardExist(jobBoardAccessKeys.TOTAL_JOBS);
  const nhsJobKey = checkBoardExist(jobBoardAccessKeys.NHS);

  useEffect(() => {
    if (status?.status === "statusCheck") {
      setActiveTab(1)
    } else {
      setActiveTab(0)
    }
  }, [status?.status]);

  // const jobCategoryTitle = postingDetails?.campaignAdvert?.jobCategory?.title;
  // const matchingIndustry = industries.find(industry => industry.value === jobCategoryTitle);


  
  const findCVLibraryObject = (jobBoardPostings, accessKey) => {
    if (jobBoardPostings && jobBoardPostings?.jobBoardMeta) {
      const jobBoardPost=jobBoardPostings?.jobBoardMeta
      for (const key in jobBoardPost) {
        const metaObject = jobBoardPost[key];
        if (metaObject?.accessKey === accessKey) {
          return metaObject;
        }
      }
    }
    return false;
  }

  const cvLibraryObject = findCVLibraryObject(postingDetails?.campaignGeneralInfo?.jobPostings[0]?.jobBoardPosting, jobBoardAccessKeys?.CV_LIBRARY);
  const reedObject = findCVLibraryObject(postingDetails?.campaignGeneralInfo?.jobPostings[0]?.jobBoardPosting, jobBoardAccessKeys?.REED);
  const monsterObject = findCVLibraryObject(postingDetails?.campaignGeneralInfo?.jobPostings[0]?.jobBoardPosting, jobBoardAccessKeys?.MONSTER);
  const nhsObject = findCVLibraryObject(postingDetails?.campaignGeneralInfo?.jobPostings[0]?.jobBoardPosting, jobBoardAccessKeys?.NHS);
  const totalObject = findCVLibraryObject(postingDetails?.campaignGeneralInfo?.jobPostings[0]?.jobBoardPosting, jobBoardAccessKeys?.TOTAL_JOBS);
  const gumTreeObject = findCVLibraryObject(postingDetails?.campaignGeneralInfo?.jobPostings[0]?.jobBoardPosting, jobBoardAccessKeys?.GUM_TREE);
  const jobBoardSummaryKeys = { cvLibraryObject, reedObject, monsterObject, nhsObject, totalObject, gumTreeObject }

  const onSocialPublish = async () => {
    if (!postingId) return;
    try {
      const data = await manualAdvertise(postingId).unwrap();
      if (data?.broadbeanUrl) {
        const newWindow = window.open(data.broadbeanUrl, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
      } else {
        toast.success(data?.message || 'Post published successfully');
      }
      await campaginRefetch();
      setActiveTab(1);
    } catch (err) {
      // Global rtkQueryErrorLogger already toasts the API error.
      // Refetch per-occurrence so socialMediaPost (if created) unlocks Next → Summary/Retry.
      await campaginRefetch();
    }
  };

  const handleSubmit = (values) => {
    const payload = {
      jpId: values?.campaignGeneralInfo?.jobPostings[0]?.id,
      campaignId: values?.campaignGeneralInfo?.jobPostings[0]?.campaignId,
      additionalInfo: []
    }
    if (values?.cvlibraryKey) {
      payload.additionalInfo.push({
        accessKey: jobBoardAccessKeys.CV_LIBRARY,
        additionalIndustry: values?.additionalIndustry?.value,
        // quickApply: values?.quickapply?.value,
        region: ""
      });
    }
    if (values?.nhsJobKey) {
      payload.additionalInfo.push({
        accessKey: jobBoardAccessKeys.NHS,
        contractType: values?.contractType?.value,
        sponsorship: values?.sponsorship?.value,
        policeWarning: values?.policeWarning?.value,
        registration: values?.registration?.value,
        vacancyStaffGroup: values?.vacancyStaffGroup?.value,
        validThrough: values?.validThrough?.length === 0 ? values?.campaignAdvert?.expiresAt ? new Date(values?.campaignAdvert?.expiresAt) : undefined : values?.validThrough,
        reason: values?.reason?.value,
        advertiseType: values?.advertiseType?.value,
        vacancyAreaOfWork: values?.vacancyAreaOfWork?.value,
        covidRelated: values?.covidRelated?.value,
        payScheme: values?.payScheme?.value,
        dbs: values?.dbs?.value,
        ...((values?.payScheme?.value === 'Hospital Medical Dental' || values?.payScheme?.value === 'Agenda for change' ) && {bandType: values?.bandType?.value}),
      });
    }
    if (values?.reedKey) {
      payload.additionalInfo.push({
        accessKey: jobBoardAccessKeys.REED,
        product: values?.product?.value,
        expiryInDays: values?.expiryInDays,
        isPublic: values?.isPublic?.value,
        isGraduate: values?.isGraduate?.value,
        sendApplicationDigest: values?.sendApplicationDigest?.value,
        parentSector: values?.parentSector?.value,
        jobSector: values?.jobSector?.value,
        salaryOTE: values?.salaryOTE?.value,
        eligibleUkOnly: values?.eligibleUkOnly?.value,
        showSalary: values?.showSalary?.value,
        hiddenSalaryDesc:values?.hiddenSalaryDesc?.value,
        coverLetterPreference: values?.coverLetterPreference?.value,
        salaryType: values?.salaryType?.value,
        region: ""
      });
    }

    if (values?.totalJobKey) {
      payload.additionalInfo.push({
        accessKey: jobBoardAccessKeys.TOTAL_JOBS,
        liveDays: values?.liveDays,
        rateUnit: values?.rateUnit?.value,
        euOnly: values?.euOnly?.value
      });
    }
    if (values?.showMonsterEditFormKey) {
      payload.additionalInfo.push({
        accessKey: jobBoardAccessKeys.MONSTER,
        inventoryType: values?.inventoryType?.value,
        jobLevel: values?.jobLevel?.value,
        jobType: values?.jobType?.value,
        industryName: values?.industryName?.value,
        desiredDuration: values?.desiredDuration?.value
      });
    }
    if(values?.cvlibraryKey || values?.reedKey || values?.totalJobKey || values?.showMonsterEditFormKey || values?.nhsJobKey)
    {  
    advertPosting({ payload })
      .unwrap()
   .then((res) => {
  let isSuccess = true;

  if (res?.resp) {
    res.resp.forEach((item) => {
      if (!item?.postingDetails?.success) {
        toast.error(item?.postingDetails?.message);
        isSuccess = false;
      }
    });

    setFailedResp(res.resp);
  }

  refetchSummaryDetail();
  setActiveTab(1);
  refetchPostingDetail();

  if (isSuccess) {
    toast.success(res?.message || 'Posting Successfully!');
  }
});

    }
  }

  const validationSchema = Yup.object().shape({
    additionalIndustry: Yup.object().when('cvlibraryKey', {
      is: true,
      then: Yup.object().required('Additional Industry is required'),
    }),

    // quickapply: Yup.object().when('cvlibraryKey', {
    //   is: true,
    //   then: Yup.object().required('Required'),
    // }),

    product: Yup.object().when('reedKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
    salaryType: Yup.object().when('reedKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
    expiryInDays: Yup.number().when('reedKey', {
      is: true,
      then: Yup.number()
        .max(42, 'Expiry In Days should not be more than 42')
        .required('Expiry In Days is required'),
    }),

    sendApplicationDigest: Yup.object().when('reedKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    parentSector: Yup.object().when('reedKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    coverLetterPreference: Yup.object().when('reedKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    isPublic: Yup.object().when('reedKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    salaryOTE: Yup.object().when('reedKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    isGraduate: Yup.object().when('reedKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    eligibleUkOnly: Yup.object().when('reedKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    showSalary: Yup.object().when('reedKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    hiddenSalaryDesc: Yup.object().when(['reedKey', 'showSalary'], {
      is: (reedKey, showSalary) => reedKey === true && showSalary?.value === false, 
      then: Yup.object().required('Required'),
      otherwise: Yup.object().nullable(), // Optional otherwise
    }),

    inventoryType: Yup.object().when('showMonsterEditFormKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    jobLevel: Yup.object().when('showMonsterEditFormKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    jobType: Yup.object().when('showMonsterEditFormKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    desiredDuration:Yup.object().when('showMonsterEditFormKey', {
      is: true,
      then:Yup.object().required('Required'),
    }),

    industryName: Yup.object().when('showMonsterEditFormKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    liveDays: Yup.number().when('totalJobKey', {
      is: true,
      then: Yup.number().required('Live days is required').min(1),
    }),

    rateUnit: Yup.object().when('totalJobKey', {
      is: true,
      then: Yup.object().required('Rate Unit is required'),
    }),

    euOnly: Yup.object().when('totalJobKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),

    contractType: Yup.object().when('nhsJobKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
    sponsorship: Yup.object().when('nhsJobKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
    policeWarning: Yup.object().when('nhsJobKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
    registration: Yup.object().when('nhsJobKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
    covidRelated: Yup.object().when('nhsJobKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
    vacancyStaffGroup: Yup.object().when('nhsJobKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
    vacancyAreaOfWork: Yup.object().when('nhsJobKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
    reason: Yup.object().when('nhsJobKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
    advertiseType: Yup.object().when('nhsJobKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
    payScheme: Yup.object().when('nhsJobKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
    dbs: Yup.object().when('nhsJobKey', {
      is: true,
      then: Yup.object().required('Required'),
    }),
   ...(!postingDetails?.campaignAdvert?.expiresAt && {validThrough: Yup.date().when('nhsJobKey', {
      is: true,
      then: Yup.date().required('Required'),
    })}), 
  });
const [clickNext,setClickNext]=useState(false);
  return (
    <>
      <Portlet>
        <PortletHeader
          title={
            <div className="d-flex align-items-center gap-2">
              <StyledLabel size="32px" weight="600">
                {'Advertise'}
              </StyledLabel>
            </div>
          }
        />
        <Formik
          initialValues={{
            ...postingDetails,
            additionalIndustry: cvLibraryObject ? { value: cvLibraryObject?.additionalIndustry, label: cvLibraryObject?.additionalIndustry } : { value: 'Other', label: 'Other' },
            // quickapply: cvLibraryObject ? {
            //   label: cvLibraryObject?.quickApply ? 'Yes' : 'No',
            //   value: cvLibraryObject?.quickApply ?? true,
            // } : { label: 'Yes', value: true },
            contractType: nhsObject ? { label: nhsObject?.contractType , value: nhsObject?.contractType}:'',
            sponsorship: nhsObject ? { label: nhsObject?.sponsorship , value: nhsObject?.sponsorship} : '',
            policeWarning: nhsObject ? { label: nhsObject?.policeWarning , value: nhsObject?.policeWarning} : '',
            registration: nhsObject ? { label: nhsObject?.registration , value: nhsObject?.registration} : '',
            vacancyStaffGroup: nhsObject ? { label: nhsObject?.vacancyStaffGroup , value: nhsObject?.vacancyStaffGroup} : '',
            reason: nhsObject ? { label: nhsObject?.reason , value: nhsObject?.reason} : '',
            advertiseType: nhsObject ? { label: nhsObject?.advertiseType , value: nhsObject?.advertiseType} : '',
            vacancyAreaOfWork: nhsObject ? { label: nhsObject?.vacancyAreaOfWork , value: nhsObject?.vacancyAreaOfWork} : '',
            covidRelated: nhsObject ? { label: nhsObject?.covidRelated , value: nhsObject?.covidRelated} : '',
            payScheme: nhsObject ? { label: nhsObject?.payScheme , value: nhsObject?.payScheme} : '',
            dbs: nhsObject ? { label: nhsObject?.dbs , value: nhsObject?.dbs} : '',
            validThrough: nhsObject ? nhsObject?.validThrough : '',
            product: reedObject ? { label: reedObject?.product, value: reedObject?.product } : '',
            expiryInDays: reedObject ? reedObject?.expiryInDays : '',
            parentSector: reedObject ? { label: reedObject?.parentSector, value: reedObject?.parentSector } : '',
            sendApplicationDigest: reedObject ? {
              label: reedObject?.sendApplicationDigest ? 'Yes' : 'No',
              value: reedObject?.sendApplicationDigest
            } : '',
            isPublic: reedObject ? {
              label: reedObject?.isPublic ? 'Yes' : 'No',
              value: reedObject?.isPublic
            } : '',
            salaryOTE: reedObject ? {
              label: reedObject?.salaryOTE ? 'Yes' : 'No',
              value: reedObject?.salaryOTE
            } : '',
            salaryType: reedObject ? {
              label: reedObject?.salaryType,
              value: reedObject?.salaryType
            } : '',
            isGraduate: reedObject ? {
              label: reedObject?.isGraduate ? 'Yes' : 'No',
              value: reedObject?.isGraduate
            } : '',
            eligibleUkOnly: reedObject ? {
              label: reedObject?.eligibleUkOnly ? 'Yes' : 'No',
              value: reedObject?.eligibleUkOnly
            } : '',
            showSalary: reedObject ? {
              label: reedObject?.showSalary ? 'Yes' : 'No',
              value: reedObject?.showSalary
            } : '',
            hiddenSalaryDesc: reedObject ? {
              label: reedObject?.hiddenSalaryDesc,
              value: reedObject?.hiddenSalaryDesc
            } : '',
            coverLetterPreference: reedObject ? { label: reedObject?.coverLetterPreference, value: reedObject?.coverLetterPreference } : '',
            liveDays: totalObject ? totalObject?.liveDays : '',
            rateUnit: totalObject ? { label: totalObject?.rateUnit, value: totalObject?.rateUnit } : '',
            euOnly: totalObject ? {
              label: totalObject?.euOnly ? 'Yes' : 'No',
              value: totalObject?.euOnly
            } : { label: 'Yes', value: true },
            inventoryType: monsterObject ? { label: monsterObject?.inventoryType, value: monsterObject?.inventoryType } : { label: 'Transactional', value: 'Transactional' },
            jobLevel: monsterObject ? { label: monsterObject?.jobLevel, value: monsterObject?.jobLevel } : '',
            jobType: monsterObject ? { label: monsterObject?.jobType, value: monsterObject?.jobType } : '',
            desiredDuration: monsterObject ? monsterDuration?.find(item=>item?.value === monsterObject?.desiredDuration) : '',
            industryName: monsterObject ? { label: monsterObject?.industryName, value: monsterObject?.industryName } : '',
            showMonsterEditFormKey: showMonsterEditFormKey,
            reedKey: reedKey,
            cvlibraryKey: cvlibraryKey,
            totalJobKey: totalJobKey,
            nhsJobKey: nhsJobKey,
            jobBoardSummaryKeys: jobBoardSummaryKeys,
            jobBoardsSummaryDetails:jobBoardsSummaryDetails
          }}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ handleSubmit, setFieldValue, values, errors, ...props }) => (
            <Form className='w-100'>
              <div className="d-flex bg-body">
                <TabsSidebar
                  sidebar={sidebar}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  values={values}
                  jobBoardsSummaryDetails={jobBoardsSummaryDetails}
                  handleSubmit={handleSubmit}
                  isBroadBeanProduct={jobBoardKeys?.some((item) =>item?.posterAccessKey === 'BB' )}
                  validationErrors={errors}
                  isLoading={postingLoading || socialPostLoading}
                  isSocialMediaSummary={isSocialMediaSummary && !needsSocialPublish}
                />

                <div className='w-100'>
                  {activeTab === 0 && (
                    // postingDetails &&
                    <div className="portlet__body-bg w-100">
                      <Wrap className="justify-content-center my-5">
                        <AdvertPostingDetails
                          showMonsterEditFormKey={showMonsterEditFormKey}
                          cvlibraryKey={cvlibraryKey}
                          totalJobKey={totalJobKey}
                          nhsJobKey={nhsJobKey}
                          reedKey={reedKey}
                          values={values}
                          setClickNext={setClickNext}
                          activeTab={activeTab}
                          setFieldValue={setFieldValue}
                          setActiveTab={setActiveTab}
                          postingLoading={postingLoading}
                          isBroadBeanProduct={jobBoardKeys?.some((item) =>item?.posterAccessKey === 'BB' )}
                          jobBoardsSummaryDetails={jobBoardsSummaryDetails}
                          isSocialMediaSummary={isSocialMediaSummary}
                          needsSocialPublish={needsSocialPublish}
                          onSocialPublish={onSocialPublish}
                          socialPostLoading={socialPostLoading}
                        />
                         
                      </Wrap>
                    </div>
                  )}
                  {activeTab === 1 && (
                    // postingDetails &&
                    <div className="portlet__body-bg w-100">
                      <Wrap className="d-flex mb-3 justify-content-center">
                        {isSocialMediaSummary ? (
                          <SocialMediaSummary socialMediaPost={socialMediaPost} campaginRefetch={campaginRefetch} />
                        ) : (
                          <JobBoardSummary jobBoardsSummaryDetails={jobBoardsSummaryDetails} refetchSummaryDetail={refetchSummaryDetail} postingDetails={postingDetails} setFieldValue={setFieldValue} refId={refId} values={values} handleSubmit={handleSubmit} jobBoardKeys={jobBoardKeys}  postingId={postingId} clickNext={clickNext} campaginRefetch={campaginRefetch} postingDetailsLoading={postingDetailsLoading} failedResp={failedResp}/>
                        )}
                      </Wrap>
                    </div>
                  )}
                </div>

              </div>
            </Form>)}</Formik>
      </Portlet>
    </>
  );
};

export default CampaignPostingDetailPage;
